import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import i18n from '../i18n';
import { reportError } from '../lib/errorReporter';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    const component = (errorInfo?.componentStack || '').trim().split('\n')[0]?.replace(/^\s*at\s+/, '').split(' ')[0];
    reportError(error, component || undefined);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
          <div className="text-center max-w-md">
            <AlertTriangle className="w-12 h-12 text-amber-700 dark:text-amber-400 mx-auto mb-4" />
            <h2 className="text-2xl font-semibold text-foreground mb-2">
              {i18n.t('errors.generic')}
            </h2>
            <p className="text-muted-foreground mb-6">
              {i18n.t('ui_common.error_boundary.description')}
            </p>
            <div className="flex gap-3 justify-center">
              <Button onClick={() => window.location.reload()}>
                <RefreshCw className="w-4 h-4 mr-2" />
                {i18n.t('common.refresh')}
              </Button>
              <Button variant="outline" onClick={() => window.location.href = '/app'}>
                {i18n.t('ui_common.error_boundary.go_to_app')}
              </Button>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="mt-6 text-left text-xs text-red-400 bg-red-950/20 p-4 rounded-lg overflow-auto max-h-40">
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
